import routes from '@constants/routes';
import { store } from '@store/index';
import { UserActions } from '@store/slices/user';

export const SESSION_EXPIRED_ERROR = 'sessionExpired';

function clearLocalAuthStorage() {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  } catch (_error) {
    // Some embedded browser contexts can block storage access; continue with redirect/reset.
  }
}

function clearReduxAuthState() {
  try {
    store.dispatch(UserActions.logout());
    store.dispatch(UserActions.setIsAuthorized(false));
  } catch (_error) {
    // Navigation after auth failure should not be blocked by local storage cleanup.
  }
}

export function clearLocalAuthState() {
  clearLocalAuthStorage();
  clearReduxAuthState();
}

export function getAuthErrorMessage(errorMessage?: string | null) {
  if (errorMessage === SESSION_EXPIRED_ERROR) {
    return 'Your session expired. Please sign in again.';
  }

  return 'Authentication failed. Please try signing in again.';
}

export function redirectToLoginWithAuthError(errorMessage = SESSION_EXPIRED_ERROR) {
  clearLocalAuthStorage();

  const params = new URLSearchParams({
    errorMessage,
  });

  window.location.replace(`${routes.loginPage}?${params.toString()}`);
}
